require('./angular-route');
module.exports = 'ngRoute';



//////////////////
// WEBPACK FOOTER
// ./~/angular-route/index.js
// module id = 40
// module chunks = 7 14 16